<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t("tiktok.settings.api_key_title") }}
            <div class="number-block">
                <img class="icon" :src="tiktokIcon"/>
                <span>{{ info?.username }}</span>
            </div>
        </h3>

        <div class="content">
            <p class="confirm">{{ $t("dialog.refresh_api_key.title") }}</p>

            <div class="action_container">
                <ButtonLoading
                    :loading="button.loading"
                    :disabled="button.disabled"
                    @click="onRefreshApiKey"
                >
                    {{ $t("dialog.refresh_api_key.button") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>



<script setup>
// core
import {ref, computed, getCurrentInstance} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore();
const tiktokIcon = require("@/assets/icons/tiktok.svg").default;
const {proxy} = getCurrentInstance();

const button = ref({
    loading: false,
    disabled: false,
});

const dialogParams = computed(() => store.state.dialogParams);
const info = computed(() => dialogParams.value?.info);

const onToggleLoadingButton = () => {
    button.value.loading = !button.value.loading;
    button.value.disabled = button.value.loading;
};

const onRefreshApiKey = async () => {
    const {info} = dialogParams.value;

    onToggleLoadingButton();

    try {
        await store.dispatch("tiktok/refreshApiKey", {
            userId: info.user_id,
            moshaToast: proxy.$moshaToast,
        });

        if (!!store.getters.getNextDialog) {
            store.commit("setDialog", store.getters.getNextDialog);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }

        await store.dispatch("tiktok/loadAccounts", {
            visibility: info.visibility,
        });
    } catch (e) {
        onToggleLoadingButton();
    }
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
